// ============================================================================
// Combat System Types and Enums
// ============================================================================
// Server-authoritative combat system for pawns and animals
// ============================================================================
// ============================================================================
// Combat Mode
// ============================================================================
export const CombatMode = {
    PASSIVE: 0, // Will not attack (run away if attacked)
    DEFENSIVE: 1, // Only attacks if attacked first
    AGGRESSIVE: 2, // Attack on sight within range
    HUNT: 3, // Actively seek and attack target
};
// ============================================================================
// Attack Type (for pawns)
// ============================================================================
export const AttackType = {
    UNARMED: 0, // Fists
    MELEE: 1, // Melee weapon
    RANGED: 2, // Ranged weapon (bows, guns)
};
// ============================================================================
// Projectile Type
// ============================================================================
export const ProjectileType = {
    NONE: 0,
    ARROW_WOOD: 1,
    ARROW_STONE: 2,
    ARROW_IRON: 3,
    ARROW_BRONZE: 4,
    ARROW_STEEL: 5,
    ARROW_SILVER: 6,
    ARROW_MITHRIL: 7,
    ARROW_STARMETAL: 8,
    LEAD_BALL: 10,
};
// ============================================================================
// Combat State
// ============================================================================
export const CombatState = {
    NONE: 0, // Not in combat
    APPROACHING: 1, // Moving to target
    ATTACKING: 2, // Actively attacking
    COOLDOWN: 3, // Attack on cooldown
    FLEEING: 4, // Running away
    STUNNED: 5, // Cannot act
    DEAD: 6, // No longer alive
};
// ============================================================================
// Combat Result
// ============================================================================
export const CombatResult = {
    HIT: 0, // Attack landed
    MISS: 1, // Attack missed
    DODGED: 2, // Target dodged
    BLOCKED: 3, // Target blocked
    PARRIED: 4, // Target parried
    CRITICAL: 5, // Critical hit
};
// ============================================================================
// Target Type
// ============================================================================
export const TargetType = {
    NONE: 0,
    PAWN: 1,
    ANIMAL: 2,
    OBJECT: 3, // Future: attackable objects
};
// ============================================================================
// Combat Constants
// ============================================================================
export const COMBAT_CONSTANTS = {
    // Range
    MELEE_RANGE: 1.5, // Tiles for melee attacks
    UNARMED_RANGE: 1.2, // Tiles for unarmed attacks
    // Timing (in ms)
    UNARMED_COOLDOWN_MS: 1500, // Base cooldown for unarmed attacks
    MELEE_COOLDOWN_MS: 1200, // Base cooldown for melee weapons
    // Damage
    UNARMED_BASE_DAMAGE: 5, // Base damage for fists
    // Combat evaluation
    AGGRO_RANGE: 8, // Tiles to auto-aggro in aggressive mode
    DEAGGRO_RANGE: 20, // Tiles to lose aggro
    DEAGGRO_TIME_MS: 5000, // Time before losing aggro when out of range
    // Hit chances
    BASE_HIT_CHANCE: 0.8, // 80% base hit chance
    DODGE_CHANCE_PER_SKILL: 0.02, // 2% per skill level
    CRIT_CHANCE: 0.05, // 5% base crit chance
    CRIT_DAMAGE_MULTIPLIER: 1.5, // 50% bonus damage on crit
    // Ranged combat - Range (tiles)
    BOW_BASE_RANGE: 10, // Base bow range
    BOW_RANGE_PER_TIER: 0.5, // Additional range per tier
    PISTOL_RANGE: 8, // Flintlock pistol range
    // Ranged combat - Timing (ms)
    BOW_COOLDOWN_MS: 2000, // Base cooldown for bows
    PISTOL_COOLDOWN_MS: 4000, // Flintlock pistol cooldown (slow reload)
    // Ranged combat - Accuracy
    BASE_RANGED_ACCURACY: 0.65, // 65% base hit chance for ranged
    ACCURACY_PER_SKILL_LEVEL: 0.015, // +1.5% accuracy per shooting level
    ACCURACY_DISTANCE_PENALTY: 0.02, // -2% per tile beyond half range
    // Ranged combat - Damage
    SKILL_DAMAGE_BONUS_PERCENT: 0.02, // +2% damage per shooting level
    // Ranged combat - Shooting XP (awarded per resolved shot)
    RANGED_SHOOTING_XP_MISS: 2, // Missed shot XP
    RANGED_SHOOTING_XP_HIT: 6, // Hit shot XP
    RANGED_SHOOTING_XP_CRIT: 8, // Critical hit shot XP
    RANGED_SHOOTING_XP_MIN_ACCURACY_FACTOR: 0.75, // Easy shots grant less XP
    RANGED_SHOOTING_XP_MAX_ACCURACY_FACTOR: 1.25, // Hard shots grant more XP
    // Melee combat - XP (awarded per resolved melee swing)
    MELEE_XP_MISS: 2,
    MELEE_XP_HIT: 5,
    MELEE_XP_CRIT: 7,
    // Toughness - XP from taking damage
    TOUGHNESS_XP_PER_DAMAGE: 0.6,
    TOUGHNESS_XP_MIN_HIT: 1,
    // Ranged combat - Projectile speed (tiles/second)
    ARROW_SPEED: 12, // Arrow flight speed
    BULLET_SPEED: 25, // Lead ball flight speed (faster)
};
//# sourceMappingURL=types.js.map